<template>
  <section class="container-fluid">
    <div class="has-text-centered">
      <div class="profile-form-container">
        <div class="mb-4 text-center">
          <h1 class="title has-text-grey">Manage Schedule</h1>
        </div>
        <div class="search-area">
          <div>
            <trainingDropdown
              v-if="courseChoices.length > 0"
              @input="trainingSelected"
              ref="trainingSearch"
              :choices="courseChoices"
            ></trainingDropdown>
            <span v-if="courseChoices.length == 0"
              >No courses available for selection. You must create a course before scheduling it.</span
            >
          </div>
        </div>

        <div v-if="gridKey.startsWith('open')">
          <grid
            :entityTypeId="courseSessionEntityType"
            :formId="courseSessionFormId"
            :entityTypeName="entityTypeName"
            :additionalActions="additionalActions"
            :checkForAdditionalActions="shouldShowAdditionalActions"
            :showFormOnEmpty="true"
            :showAddButton="showGridAddButton()"
            :getDynPrimaryEntity="passDynPrimaryEntity()"
            :key="gridKey"
            :section="section"
            :primaryEntity="gridPrimaryEntity"
            ref="sessionGrid"
            :additionalShowColumns="additionalColumns"
            :additionalActionsOnColumn="true"
            :allowDownload="false"
            :defaultFilters="gridDefaultFilters"
            :parentProps="gridParentProps"
            :getDynParentProps="passDynParentProps()"
            :parentFormId="courseFormId"
            :showParentPropsInForm="true"
            :showDisable="false"
            :basePageSize="gridPageSize"
            :baseCurrentPage="gridCurrentPage"
            @setPageSize="setPageSize"
            @setCurrentPage="setCurrentPage"
          >
          </grid>
        </div>
        <modal v-show="isModalVisible" @close="closeModal" :isModalVisible="isModalVisible">
          <h2 slot="header">
            <span v-if="currentCourseName">{{ currentCourseName }}</span> Registration and Attendance Details
          </h2>
          <div slot="body">
            <div v-if="childGridKey.startsWith('open')">
              <grid
                :entityTypeId="enrollmentEntityType"
                :formId="enrollmentFormId"
                :key="childGridKey"
                :entityTypeName="enrollmentEntityTypeName"
                :showFormOnEmpty="false"
                :showAddButton="true"
                :showEdit="false"
                :showDisable="false"
                :primaryEntity="enrollmentPrimaryEntity"
                :section="section"
                ref="enrollmentGrid"
                :allowDownload="true"
                :parentProps="gridSectionProps"
                :parentFormId="courseSessionFormId"
                :showParentPropsInForm="true"
                :additionalActionsOnColumn="true"
                :additionalActions="childAdditionalActions"
                @dirty="$emit('dirty', $event)"
                :multiRowSelect="multiRowSelect"
                :allowSelectAll="allowSelectAll"
                :allowClearSelection="allowClearSelection"
                :tableActions="getTableActions()"
                @tableAction="tableAction"
                :basePageSize="enrollmentGridPageSize"
                :baseCurrentPage="enrollmentGridCurrentPage"
                @setPageSize="setEnrollmentPageSize"
                @setCurrentPage="setEnrollmentCurrentPage"
              >
              </grid>
            </div>
          </div>
        </modal>
        <modal v-show="isMessageModalVisible" @close="closeMessageModal" :isModalVisible="isMessageModalVisible">
          <h2 slot="header">Send a Message</h2>
          <div slot="body">
            <div v-if="composeKey != ''">
              <MessageCompose
                :inputForm="inputForm"
                :exitForm="confirmExitForm"
                :form="composeForm"
                :composeEmail="composeEmail"
                :compose="compose"
                :key="composeKey"
                :limitText="limitText"
                :userSearch="userSearch"
                :users="users"
                :isLoading="isLoading"
                :twoCharacterMessage="twoCharacterMessage"
                :emptySetMessage="emptySetMessage"
                :noResultMessage="noResultMessage"
                :usersSelected="usersSelected"
                :defaultSelectedUsers="defaultSelectedUsers"
                :showTitle="true"
                :bulkUserMode="bulkUserMode"
                :toUserString="toUserString"
              >
              </MessageCompose>
            </div>
          </div>
        </modal>
        <div v-if="childGridKey == 'closed'" style="min-height: 200px"></div>
      </div>
    </div>
  </section>
</template>

<script>
import trainingDropdown from './training-dropdown.vue';
import MessageCompose from '../../messaging/message-compose.vue';
import RequestPrompt from '../../utility/dialog/request-prompt';
import RequiredPrompt from '../../utility/dialog/request-prompt-required';
import SelectPromptRequired from '../../utility/dialog/select-prompt-required';
import { mapGetters } from 'vuex';
export default {
  name: 'ScheduleTraining',
  components: {
    trainingDropdown,
    MessageCompose
  },
  data() {
    return {
      isBusy: false,
      courseSessionEntityType: 24,
      courseEntityType: 23,
      courseFormId: 21,
      courseSessionFormId: 22,
      enrollmentEntityType: 26,
      enrollmentFormId: 24,
      entityType: 1,
      userEntityType: 1,
      userFormId: 1,
      entityTypeName: 'Training Session',
      enrollmentEntityTypeName: 'Student Details',
      childEntityTypeName: '',
      primaryEntity: {},
      userPrimaryEntity: {},
      enrollmentPrimaryEntity: {},
      section: {},
      sectionPrimaryEntity: {},
      courseEntity: {},
      gridPrimaryEntity: {},
      additionalActions: [
        {
          title: 'Manage Session',
          icon: 'user-check',
          click: this.manageAttendance,
          check: this.shouldShowAction
        },
        {
          title: 'Delete Session',
          icon: 'trash',
          click: this.deleteSection,
          check: this.shouldShowDeleteSection
        }
      ],
      childAdditionalActions: [
        {
          title: 'Send a Message',
          icon: 'paper-plane',
          click: this.sendMessage,
          check: this.shouldShowSendMessage
        },
        {
          title: 'Cancel Registration',
          icon: 'calendar-times',
          click: this.cancelRegistration,
          check: this.shouldShowCancel
        },
        {
          title: 'Review Out of Region Enrollment Request',
          icon: 'glasses',
          click: this.setVerification,
          check: this.canVerify
        },
        {
          title: 'View Certificate',
          icon: 'paperclip',
          click: this.showCertificate,
          check: this.shouldShowCertificate
        }
      ],
      additionalColumns: [],
      gridParentProps: [],
      gridSectionProps: [],
      isModalVisible: false,
      isMessageModalVisible: false,
      activeId: '',
      activeUser: {},
      isDirty: false,
      searchedName: '',
      gridKey: 'closed',
      childGridKey: 'closed',
      searchDefaultFilters: [
        {
          operation: 'Contains',
          filterValue: '',
          filterColumn: { propertyName: 'SearchableName' }
        },
        {
          operation: 'Equals',
          filterValue: 'true',
          filterColumn: { propertyName: 'HasECProfessionalRoleOnly' }
        }
      ],
      gridDefaultFilters: [],
      courseChoices: [],
      currentCourseName: '',
      composeForm: false,
      composeKey: '',
      composeEmail: {
        subject: '',
        message: '',
        to: null
      },
      selectedUsers: [],
      defaultSelectedUsers: [],
      users: [],
      isLoading: false,
      twoCharacterMessage: 'At least two characters are required for search',
      emptySetMessage: 'No results found',
      noResultMessage: 'At least two characters are required for search',
      sectionDateTime: null,
      multiRowSelect: true,
      allowSelectAll: true,
      allowClearSelection: true,
      bulkUserMode: false,
      toUserString: '',
      gridPageSize: 5,
      gridCurrentPage: 1,
      enrollmentGridPageSize: 5,
      enrollmentGridCurrentPage: 1
    };
  },
  computed: {
    ...mapGetters(['profile', 'roles', 'isAuthenticated']),
    hasAdminRole: function () {
      if (this.roles && this.roles.length > 0 && this.roles.includes('AdminUser')) return true;
      return false;
    },
    hasTrainerRole: function () {
      if (this.roles && this.roles.length > 0 && this.roles.includes('250')) return true;
      return false;
    },
  },
  created() {
    this.isBusy = true;
    const body = {};

    this.$store
      .dispatch('courseSearchRequest', body)
      .then(async (result) => {
        this.isBusy = false;
        this.courseChoices = result;
      })
      .catch((errors) => {
        this.isBusy = false;
        this.courseChoices = [];
      });
  },
  methods: {
    setPageSize(size) {
      this.gridPageSize = parseInt(size);
    },
    setCurrentPage(page) {
      this.gridCurrentPage = parseInt(page);
    },
    setEnrollmentPageSize(size) {
      this.enrollmentGridPageSize = parseInt(size);
    },
    setEnrollmentCurrentPage(page) {
      this.enrollmentGridCurrentPage = parseInt(page);
    },
    async trainingSelected(course) {
      this.isBusy = true;
      if (course) {
        if (course == 'ALL') {
          this.gridPrimaryEntity = {};
          this.gridParentProps = [];
          this.courseEntity = {};
          this.gridKey = 'openALL';
          this.isBusy = false;
        } else {
          const body = { trainingId: course };
          this.$store.dispatch('coursePropsRequest', body).then((result) => {
            this.gridParentProps = result;
            this.courseEntity = course;
            this.gridPrimaryEntity = { Id: course, EntityTypeId: this.courseEntityType }; //the basic parent entity for the grid
            this.gridKey = 'open' + course;
          });
        }
      } else {
        this.gridKey = 'closed';
        this.gridPrimaryEntity = {};
        this.gridParentProps = [];
        this.courseEntity = {};
        this.isBusy = false;
      }
    },
    reloadEnrollGrid(resetSection) {
      this.childGridKey += '-1';
      if (resetSection === true) this.section.recordIsLocked = true;
    },
    showGridAddButton() {
      if (!this.gridPrimaryEntity.Id) return false;
      else return true;
    },
    passDynPrimaryEntity() {
      if (!this.gridPrimaryEntity.Id) return this.getDynPrimaryEntityForGrid;
      else return undefined;
    },
    passDynParentProps() {
      if (!this.gridPrimaryEntity.Id) return this.getDynParentPropsForGrid;
      else return undefined;
    },
    shouldShowAdditionalActions(item) {
      return this.shouldShowAction(item);
    },
    shouldShowAction(item) {
      return true;
    },
    rowAction(item) {
      return true;
    },
    getDynPrimaryEntityForGrid(item) {
      return { Id: item.courseId, EntityTypeId: this.courseEntityType };
    },
    async tableAction(eventVal, items, data) {
        if (eventVal == 'send') {
          this.bulkSendMessage(items, data);
        } else if (eventVal == 'cancel') {
          this.bulkCancelRegistration(items, data);
        } else if (eventVal == 'record') {
          this.bulkManageAttendance(items, data);
        }
    },
    getTableActions() {
      const actions = [
          {
            status: 'Message Sent',
            verb: 'send',
            button: {
              classes: 'btn mr-2 tnpalBGGreen px-2',
              title: 'Send Message',
              click: 'tableAction("send")',
              icon: 'paper-plane',
            },
          },
          {
            status: 'Canceled',
            verb: 'cancel',
            button: {
              classes: 'btn mr-2 tnpalBGRed px-2',
              title: 'Cancel',
              click: 'tableAction("cancel")',
              icon: 'calendar-times'
            },
            check: this.showBulkCancel
          }
        ];
      const now = new Date();
      if (this.sectionDateTime < now)
        actions.push(
          {
            status: 'Manage Attendance',
            verb: 'record',
            button: {
              classes: 'btn mr-2 tnpalBGGreen px-2',
              title: 'Manage Attendance',
              click: 'tableAction("record")',
              icon: 'tasks',
            },
            check: this.showBulkAttendance
          }
        );
      return actions;
    },
    alertsDisplay(response) {
      const alertTitle = 'Review Out of Region Request';
      if (response == -2) {
        const options = { title: alertTitle };
        this.$dialogs.alert(
          `Unable to register. ${this.userName} is already registered for ${this.section.courseName}: ${this.section.sectionName}.`,
          options
        );
      } else if (response == -3 || response == -4) {
        const options = { title: alertTitle };
        this.$dialogs.alert(
          `Registration for ${this.section.courseName}: ${this.section.sectionName} is full. Registration is unavailable at this time.`,
          options
        );
      } else {
        const options = { title: alertTitle };
        this.$dialogs.alert('Unable to complete registration review process. An error occurred.', options);
      }
    },
    shouldShowDisableSection(item) {
      //if (this.hasAdminRole) return true;
      return false;
    },
    shouldShowDeleteSection(item) {
      if (this.hasTrainerRole && !item.hasHadEnrollments) return true;
      return false
    },
    shouldShowCancel(item) { //This is for registration cancellation
      if (!this.section || this.section.recordIsLocked) return false;
      if (item && ['Unregistered', 'System Cancellation', 'Pending Approval', 'Denied'].includes(item.status))
        return false;
      return true;
    },
    shouldShowCertificate(item) {
      if (!this.section) return false;
      if (item && item.certificate)
        return true;
      return false;
    },
    shouldShowSendMessage(item) {
      if (item && item.status === 'Unregistered') return false;
      return true;
    },
    async showCertificate(item) {
      const url ='/api/file/c/' + item.certificate;
      window.open(url);
    },
    deleteSection(item) {
      const options = { title: 'Delete Course Session', okLabel: 'Confirm', cancelLabel: 'Cancel' };
      this.$dialogs
        .confirm('Are you sure you want to delete this session?', options)
        .then((res) => {
          if (res && res.ok && res.ok == true) {
            const body = {
              courseSectionId: item.id,
              userId: this.$attrs.primaryentity.Id
            };
            this.isBusy = true;
            this.$store
              .dispatch('deleteSectionRequest', body)
              .then(async (response) => {
                this.gridKey += '-1';
              })
              .catch((errors) => {
                this.isBusy = false;
              });
          }
        })
        .catch((errors) => {
          this.isBusy = false;
        });
    },
    cancelRegistration(item) {
      const regText = `Are you sure you want to cancel this registration? If so, please enter an optional comment and click Confirm.`;
      const regOptions = {
        title: 'Cancel Registration',
        okLabel: 'Continue',
        cancelLabel: 'Cancel',
        prompt: {
          invalidMessage: '',
          component: RequestPrompt
        }
      };
      this.isBusy = true;
      this.$dialogs
        .prompt(regText, regOptions)
        .then((res) => {
          if (res && res.ok && res.ok == true) {
            this.cancelRegistrationConfirmed(item, res.value);
          }
          this.$emit('dirty', false);
          this.isDirty = false;
        })
        .catch((error) => {
          this.$emit('dirty', false);
          this.isDirty = false;
        });
    },
    cancelRegistrationConfirmed(item, comment) {
      const body = {
        courseSectionId: item.courseSectionId,
        userIds: [item.userId],
        comment: comment
      };
      this.isBusy = true;
      this.$store
        .dispatch('cancelRegistrationRequest', body)
        .then(async (response) => {
          const dispDate = this.$formatGridDate(item.courseStartDate, false, true);
          this.composeEmail.subject = `${item.courseSectionName} ${dispDate} - Registration Cancelled`;
          this.sendMessage(item);
          this.childGridKey += '-1';
        })
        .catch((errors) => {
          this.isBusy = false;
        });
    },
    async setVerification(item) {
      return await new Promise((resolve, reject) => {
        if (!this.primaryEntity) {
          //What's this for?
          //if (!this.primaryEntity || !this.organizationId) {
          resolve(false);
        }
        const promptComponent = RequiredPrompt;
        const promptText = `To approve/decline out of region registration request for ${item.userName}, please enter a required comment and click Approve or Decline.`;
        const promptTitle = `Request Review for Out of Region Training`;
        const options = {
          title: promptTitle,
          okLabel: 'Approve',
          cancelLabel: 'Cancel',
          notOkLabel: 'Decline',
          prompt: { invalidMessage: '', component: promptComponent }
        };
        this.$dialogs
          .prompt(promptText, options)
          .then((res) => {
            if (res && res.ok != false) {
              //res.ok=null when declined
              const body = {
                accepted: res.ok ? true : false,
                courseSectionId: item.courseSectionId,
                userId: item.userId,
                comment: res.value
              };
              this.isBusy = true;
              this.$store
                .dispatch('acceptRejectOverrideRequest', body)
                .then((response) => {
                  if (response > 0) {
                    this.reloadEnrollGrid(false);
                    resolve(true);
                  } else {
                    this.alertsDisplay(response);
                    this.reloadEnrollGrid(false);
                    resolve(false);
                  }
                })
                .catch((errors) => {
                  this.isBusy = false;
                  reject(errors);
                });
            }
            resolve(false); //dialog closed or cancelled
          })
          .catch((error) => reject(error));
      });
    },
    canVerify(item) {
      if (item && ['Pending Approval'].includes(item.status)) return true;
      return false;
    },
    sendMessage(item) {
      this.composeForm = true;
      const toUser = { name: item.userName, email: item.name, id: item.userId };
      this.defaultSelectedUsers = [toUser];
      this.composeKey = `open${item.userId}`;
      this.showMessageModal();
    },
    bulkSendMessage(items, data) {
      this.selectedUsers = data.filter((d) => items.includes(d.id)).map((i) => {return {'name': i.userName, 'email': i.name, 'id': i.userId}});
      this.composeForm = true;
      //const toUser = { name: item.userName, email: item.name, id: item.userId };
      this.defaultSelectedUsers = [];
      this.bulkUserMode = true;
      this.toUserString = this.selectedUsers.map((u) => u.name ).join(', ');
      this.composeKey = `open${this.selectedUsers[0].userId}`;
      this.showMessageModal();
    },
    showBulkAttendance(gridData) {
      if (!this.section || this.section.recordIsLocked) return false;
      const unsetItems = gridData.filter((g) => !['Completed','Absent'].includes(g.attendance));
      return unsetItems.length;
    },
    showBulkCancel(gridData) { 
      if (!this.section || this.section.recordIsLocked) return false;
      const okItems = gridData.filter((g) => !['Unregistered', 'System Cancellation', 'Pending Approval', 'Denied'].includes(g.status));
      return okItems.length;
    },

    bulkCancelRegistration(items, data) {
      const selected = data.filter((d) => items.includes(d.id) && !['Unregistered', 'System Cancellation', 'Pending Approval', 'Denied'].includes(d.status));
      if (selected.length == 0) {
        this.$dialogs.alert('No chosen users are eligible for cancellation.', { title: 'Unable to cancel registration.' });
        return;
      }
      let userStr = selected.map((u) =>  u.userName ).join(', ');
      const i = userStr.lastIndexOf(', ');
      if (i >= 0) userStr = (userStr.substring(0, i) + ' and ' + userStr.substring(i+2));
      const regText = `Are you sure you want to cancel registration for the user${selected.length > 1 ? 's' : ''} <b>${userStr}</b>? If so, please enter an optional comment and click Confirm.`;
      const regOptions = {
        title: 'Cancel Registration',
        okLabel: 'Confirm',
        cancelLabel: 'Cancel',
        prompt: {
          invalidMessage: '',
          component: RequestPrompt
        }
      };
      this.isBusy = true;
      this.$dialogs
        .prompt(regText, regOptions)
        .then((res) => {
          if (res && res.ok && res.ok == true) {
            this.bulkCancelRegistrationConfirmed(items, data, res.value);
          }
          this.$emit('dirty', false);
          this.isDirty = false;
        })
        .catch((error) => {
          this.$emit('dirty', false);
          this.isDirty = false;
        });
    },
    async bulkCancelRegistrationConfirmed(items, data, comment) {
      const selected = data.filter((d) => items.includes(d.id) && !['Unregistered', 'System Cancellation', 'Pending Approval', 'Denied'].includes(d.status));
      if (selected.length == 0) return;
      const userIds = selected.map((u) => u.userId);
      const body = {
        courseSectionId: selected[0].courseSectionId,
        userIds: userIds,
        comment: comment
      };
      this.isBusy = true;
      this.$store
        .dispatch('cancelRegistrationRequest', body)
        .then((response) => {
          const dispDate = this.$formatGridDate(selected[0].courseStartDate, false, true);
          this.composeEmail.subject = `${selected[0].courseSectionName} ${dispDate} - Registration Cancelled`;
          this.bulkSendMessage(items, data);
          this.childGridKey += '-1';
        })
        .catch((errors) => {
          this.isBusy = false;
        });
    },
    async bulkManageAttendance(items, data) {
      const selected = data.filter((d) => items.includes(d.id) && d.status == 'Registered' && !['Absent','Completed'].includes(d.attendance));
      const enrollmentIds = selected.map((u) => u.id);
      if (enrollmentIds.length == 0) {
        this.$dialogs.alert('All chosen users have attendance set already.', { title: 'Unable to set attendance.' });
        return;
      }
      let userStr = selected.map((u) =>  u.userName ).join(', ');
      const i = userStr.lastIndexOf(', ');
      if (i >= 0) userStr = (userStr.substring(0, i) + ' and ' + userStr.substring(i+2));
      const opts = [{'key':'1','value':'Completed'},{'key':'2','value':'Partially Completed'},{'key':'3','value':'Absent'}];
      const regText = 'Please select an attendance status for the users <b>' + userStr + '</b>.';
      const regOptions = {
        title: 'Select Attendance Status',
        okLabel: 'Confirm',
        cancelLabel: 'Cancel',
        prompt: {
          invalidMessage: '',
          component: SelectPromptRequired,
          stimulus: 'Select status',
          selectOptions: opts
        }
      };
      this.$dialogs
        .prompt(regText, regOptions)
        .then((res) => {
          if (res && res.ok != false) {
            this.isBusy = true;
            const status = res.value;
            const body = {
              enrollmentRecordIds: enrollmentIds,
              status: status
            };
            if (status === '1' || status === '3') {
              const options = { title: 'Confirm Attendance Status', okLabel: 'Confirm', cancelLabel: 'Cancel' };
              const msg =
                  '<p>Are you sure you want to mark the user' + (selected.length > 1 ? 's' : '') + ' ' +
                  userStr +
                  ' as "' +
                  (status == 1 ? 'Completed' : 'Absent') +
                  '" ?</p><p>* You will not be able to make changes once attendance status has been submitted.</p><p>Thanks,</p><p>Alabama Pathways Team';
              this.$dialogs
                .confirm(msg, options)
                .then((res) => {
                  if (res && res.ok && res.ok == true) {
                    this.$store.dispatch('setAttendanceRequest', body).then((result) => {
                      this.childGridKey += "-1";
                    });
                  }
                });
              this.isBusy = false;
            } else {
              this.$store.dispatch('setAttendanceRequest', body).then((result) => {
                this.childGridKey += "-1";
                this.isBusy = false;
              }); 
            }
        }
      });

    },
    manageAttendance(item) {
      if (item && item.id) {
        this.isBusy = true;
        const body = { trainingId: item.id };
        this.$store.dispatch('courseSectionPropsRequest', body).then((result) => {
          this.gridSectionProps = result;
          this.currentCourseName = item.sectionName;
          this.enrollmentPrimaryEntity = {
            Id: item.id,
            EntityTypeId: this.courseSessionEntityType,
            DisplayValue: item.sectionName
          };
          this.section = item;
          this.sectionDateTime = new Date(item.trainingEndDate);
          this.childGridKey = 'open' + item.id;
          this.showModal();
        });
      } else {
        this.isBusy = false;
      }
    },
    showModal() {
      this.isModalVisible = true;
    },
    async dirtyCheck() {
      return await new Promise((resolve, reject) => {
        if (this.isDirty && this.isAuthenticated) {
          const options = {
            title: 'Unsaved Data Warning',
            cancelLabel: 'Cancel'
          };
          this.$dialogs
            .confirm('Are you sure you want to close without saving?', options)
            .then((res) => {
              if (res && res.ok && res.ok == true) {
                this.$emit('dirty', false);
                this.isDirty = false;
                resolve(true);
              } else {
                resolve(false);
              }
            })
            .catch((error) => reject(error));
        } else resolve(true);
      });
    },
    async closeModal(type) {
      const userAccept = await this.dirtyCheck();
      if (userAccept) {
        this.isModalVisible = false;
        this.childGridKey = 'closed';
        this.gridKey += '-1';
      }
    },
    showMessageModal() {
      this.isMessageModalVisible = true;
    },
    async closeMessageModal(type) {
      const userAccept = await this.dirtyCheck();
      if (userAccept) {
        this.isMessageModalVisible = false;
        this.composeKey = '';
        this.users = [];
        this.defaultSelectedUsers = [];
        this.selectedUsers = [];
        this.composeForm = false;
        this.bulkUserMode = false;
        this.toUserString='';
      }
    },
    formDirty(eventVal) {
      this.isDirty = eventVal;
      this.$emit('dirty', eventVal);
    },
    inputForm() {
      this.composeForm = true;
      this.composeKey = '';
    },
    async confirmExitForm() {
      let confirmed = true;
      if (
        this.composeEmail &&
        (this.composeEmail.subject || this.composeEmail.message || this.selectedUsers.length > 0)
      ) {
        confirmed = await new Promise((resolve, reject) => {
          const options = { title: 'Warning', cancelLabel: 'Cancel' };
          this.$dialogs
            .confirm('Are you sure you want to close without sending?', options)
            .then((res) => {
              if (res && res.ok && res.ok == true) {
                resolve(true);
              }
              resolve(false);
            })
            .catch((error) => {
              resolve(false);
            });
        });
      }
      if (confirmed) {
        this.exitForm();
        this.closeMessageModal();
      }
      return confirmed;
    },
    exitForm() {
      this.composeForm = false;
      this.composeKey = '';
      this.selectedUsers = [];
      this.defaultSelectedUsers = [];
      this.users = [];
      this.composeEmail = {
        subject: '',
        message: '',
        to: null
      };
      this.bulkUserMode = false;
      this.toUserString='';
    },
    async compose() {
      //make sure they have selected a recipient
      if (this.selectedUsers.length > 0) {
        let confirmed1 = true;
        if (!this.composeEmail.subject) {
          //ask if they want to send with no subject
          confirmed1 = await new Promise((resolve, reject) => {
            const options = { title: 'Warning', cancelLabel: 'Cancel' };
            this.$dialogs
              .confirm('Are you sure you send a message with an empty subject?', options)
              .then((res) => {
                if (res && res.ok && res.ok == true) {
                  resolve(true);
                }
                resolve(false);
              })
              .catch((error) => {
                resolve(false);
              });
          });
        }

        let confirmed2 = true;
        if (!this.composeEmail.message) {
          //ask if they want to send with no body
          confirmed2 = await new Promise((resolve, reject) => {
            const options = { title: 'Warning', cancelLabel: 'Cancel' };
            this.$dialogs
              .confirm('Are you sure you send a message with an empty body?', options)
              .then((res) => {
                if (res && res.ok && res.ok == true) {
                  resolve(true);
                }
                resolve(false);
              })
              .catch((error) => {
                resolve(false);
              });
          });
        }

        if (confirmed1 && confirmed2) {
          return await new Promise((resolve, reject) => {
            const body = {
              body: this.composeEmail.message,
              subject: this.composeEmail.subject,
              recipients: this.selectedUsers
            };
            this.isBusy = true;
            this.$store
              .dispatch('sendMessageRequest', body)
              .then((response) => {
                //Close message modal after reply sent.
                this.isMessageModalVisible = false;
                this.isBusy = false;
                this.exitForm();
                this.$dialogs.alert('Your message was sent successfully.', { title: 'Success' });
                this.composeEmail.subject = '';
                resolve(true);
              })
              .catch((errors) => {
                this.isMessageModalVisible = false;
                this.isBusy = false;
                this.exitForm();
                this.$dialogs.alert('Your message could not be sent at this time. Please try again later.', {
                  title: 'Error'
                });
                this.composeEmail.subject = '';
                resolve(false);
              });
          });
        }
      } else {
        this.$dialogs.alert('No recipient selected', { title: 'Error' });
      }
    },
    limitText(count) {
      return `and ${count} other users`;
    },
    userSearch(query) {
      const lettersLimit = 2;
      if (query.length < lettersLimit) {
        this.noResultMessage = this.twoCharacterMessage;
        this.users = [];
        return;
      }

      this.isLoading = true;
      const body = { searchString: query };

      this.$store
        .dispatch('messageUserSearchRequest', body)
        .then((result) => {
          this.isLoading = false;
          this.users = result;
          if (!this.users.length) {
            this.noResultMessage = this.emptySetMessage;
          }
        })
        .catch((errors) => {
          this.isLoading = false;
        });
    },
    usersSelected(users) {
      this.selectedUsers = users;
    }
  }
};
</script>
